import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import Login from './Login';
import Logout from './Logout';
import Home from './Home';
import Game from './Game';
// import Logout from './Logout';
import './App.css';
// var api = require('./utils/api.js');

//<Route path="/" component={App}>
//    </Route>
class Main extends Component {
  
  constructor(args) {
    super(args);
    this.state = {
    };
    //console.log('In main component...');
    //console.log(this.props);
  }


  
  render() {
    return (
      <main>
        {this.props.user.authenticated
            ? (
              <Switch>
                <Route exact path='/' render={(props) => (<Home {...this.props} />)}/>
                <Route exact path='/game' render={(props) => (<Game {...this.props} />)}/>
                <Route path='/logout' render={(props) => (<Logout {...this.props} />)} />
              </Switch>
            ) : (
              <Switch>
                <Route exact path='/' render={(props) => (<Login {...this.props} />)} />
                <Route path='/login'  render={(props) => (<Login {...this.props} />)} />
              </Switch>
            )}
      </main>
    );
  }
}

export default withRouter(Main);



// WEBPACK FOOTER //
// ./src/Main.js